/**
 * Created by neo on 29.05.17.
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import FlightOffer from '../../Store/FlightOffer';
import type { FlightOfferAircraft } from '../../Store/FlightOffer';
import BookingRequest from '../../Store/Booking/BookingRequest';
import { Row, Col, Container, Button } from 'reactstrap';
import FlightDetails from './FlightDetails';
import ClientInfo from '../ClientInfo';
import PassengerInfo from '../PassengerInfo';
import ProcessingModal from '../ProcessingModal';
import CheckoutSection from '../CheckoutSection';

type Props = {
  params: any
};

@observer
export class FlightOfferBookingScreen extends Component {

  state: {
    flightOffer: FlightOffer,
    booking: BookingRequest,
    isOpen: boolean,
    showPassenger: boolean,
    showClientInfo: boolean,
    showCheckout: boolean,
    step: boolean,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      flightOffer: null,
      booking: null,
      isOpen: false,
      showPassenger: false,
      showClientInfo: true,
      showCheckout: false,
      step: 1,
    };
  }

  componentWillMount() {
    const { location: { query }, params: { flightOfferId } } = this.props;
    this.load(flightOfferId, query.aircraft, query.passengers, query.start_time, query.exclusive === 'true', query.giftcode);
  }

  async load(flightOfferId: string, aircraftId: string, passengerCount: number, start_time: string, exclusive: boolean, giftCode: string) {
    const flightOffer = await FlightOffer.get(flightOfferId, exclusive);
    const aircraft = flightOffer.aircraft_offers.find((a: FlightOfferAircraft) => +a.id === +aircraftId);
    const booking = new BookingRequest({ flightOffer, exclusive, aircraft, start_time, voucher: { code: giftCode } });
    booking.setPassengerCount(exclusive ? booking.maxPassengers : passengerCount);

    if (giftCode || booking.promo_code.code) {
      booking.applyDiscounts();
    }

    this.setState({ flightOffer, booking });
  }

  handleBooking = (token) => {
    const { booking } = this.state;

    if (token) {
      booking.payment.token = token.id;
    }

    this.setState({ isOpen: true });
  };

  handleModalClose = (success) => {
    if (success) {
      this.props.router.replace('/');
    } else {
      this.setState({
        isOpen: false,
      });
    }
  };

  nextStep = () => {
    this.setState({ step: 2 }, () => {
      window.scrollTo(0, 0);
    });
  };

  previousStep = () => {
    this.setState({ step: 1 }, () => {
      window.scrollTo(0, 0);
    });
  };

  renderStep() {
    const { step, flightOffer, booking, submitting, error } = this.state;
    const { t } = this.props;
    const title = flightOffer.title;

    if (step === 1) {
      return (
        <div>
          <Row>
            <Col className='mb-4'>
              <h1 className='mb-1'>{t('Booking: {{title}}', { title })}</h1>
              <div>{t('Step 1/2')}</div>
            </Col>
          </Row>
          <Row className='align-items-stretch mb-4'>
            <Col md='6'>
              <ClientInfo
                client={booking}
              />
            </Col>
            <Col md='6'>
              <PassengerInfo
                booking={booking}
                enabled={booking.validClient}
              />
            </Col>
          </Row>
          <Row>
            <Col className='text-right'>
              <Button
                color='primary'
                onClick={this.nextStep}
                disabled={!booking.validClient || !booking.check_insurance_info || !booking.check_safety_info}
              >{t('Continue to payment')}</Button>
            </Col>
          </Row>
        </div>
      );
    } else if (step === 2) {
      return (
        <div>
          <Row>
            <Col className='mb-4'>
              <h1 className='mb-1'>{t('Payment: {{title}}', { title })}</h1>
              <div>{t('Step 2/2')}</div>
            </Col>
          </Row>
          <Row>
            <Col>
              <CheckoutSection
                enabled={booking.validClient}
                booking={booking}
                handlePayment={this.handleBooking}
                showSubmitButton={false}
              />
            </Col>
          </Row>

          {/*buttons*/}
          <Row>
            <Col sm={12} md={6} className='mb-4 mb-md-0'>
              <Button size='lg' color='secondary' className='d-block d-md-inline'
                      onClick={this.previousStep}>{t('Back to Info')}</Button>
            </Col>
            <Col sm={12} md={6} className='text-right'>
              {booking.payment.name === 'ONLINE' ? (
                <Button
                  color='primary'
                  size='lg'
                  disabled={booking.invalid || submitting}
                  className='d-block d-md-inline-block'
                  type='submit'
                  form='bookingForm'
                >
                  {submitting ? t('Sending...') : t('Buchen')}
                </Button>
              ) : (
                <Button
                  color='primary'
                  size='lg'
                  className='d-block d-md-inline-block'
                  disabled={booking.invalid}
                  onClick={this.handleBooking}
                >
                  {t('Buchen')}
                </Button>
              )}
            </Col>
          </Row>
        </div>
      );
    }
    return null;
  }

  render() {
    const { flightOffer, booking } = this.state;
    const { t } = this.props;

    if (flightOffer) {
      return (
        <Container>
          {this.renderStep()}
          <ProcessingModal
            booking={booking}
            isOpen={this.state.isOpen}
            onCloseRequest={this.handleModalClose}
            endpoint='flightbooking'
          />
        </Container>
      );
    }
    return null;
  }
}

export default translate()(FlightOfferBookingScreen);



// WEBPACK FOOTER //
// ./src/App/Booking/FlightOffer/index.js